import * as React from 'react';
import { Divider, Dropdown, Form } from 'semantic-ui-react';

import Panel from 'src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Panel';
import capitalizar from 'src/modulos/Matriculas/IngresoNuevaMatricula/utils/capitalizar';
import RegionesComunas, {
    Datos as RegionesComunasDatos,
    inicial as regionesComunasInicial,
} from './componentes/RegionesComunas';

export interface Datos extends RegionesComunasDatos {
    calle: string;
    numero: string;
    dpto: string;
    block: string;
    poblacion: string;
    copiarDesdeLista: { texto: string; obtenerDireccionOrigen(): Datos }[];
}

export const inicial: Datos = {
    ...regionesComunasInicial,
    calle: '',
    numero: '',
    dpto: '',
    block: '',
    poblacion: '',
    copiarDesdeLista: [],
};

interface Props {
    titulo: string;
    requeridos?: boolean;
    direccion: Datos;
    onChange(direccion: Datos): void;
}

class Direccion extends React.PureComponent<Props> {
    public render() {
        const { titulo, requeridos = false, direccion, onChange } = this.props;

        return (
            <Panel titulo={titulo}>
                <Dropdown text='Copiar desde'>
                    <Dropdown.Menu>
                        {direccion.copiarDesdeLista.map((item, index) => (
                            <Dropdown.Item
                                key={index}
                                text={item.texto}
                                onClick={() => {
                                    onChange(item.obtenerDireccionOrigen());
                                }}
                            />
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
                <Divider />

                <Form.Group widths='4'>
                    <Form.Input
                        label='Calle'
                        placeholder='Almirante Barroso'
                        required={requeridos}
                        value={direccion.calle}
                        onChange={(_e, { value }) => {
                            onChange({ ...direccion, calle: capitalizar(value) });
                        }}
                    />
                    <Form.Input
                        label='Número'
                        placeholder='123'
                        required={requeridos}
                        value={direccion.numero}
                        onChange={(_e, { value }) => {
                            onChange({ ...direccion, numero: value });
                        }}
                    />
                    <Form.Input
                        label='Dpto'
                        placeholder='25'
                        value={direccion.dpto}
                        onChange={(_e, { value }) => {
                            onChange({ ...direccion, dpto: value });
                        }}
                    />
                    <Form.Input
                        label='Block'
                        placeholder='A1'
                        value={direccion.block}
                        onChange={(_e, { value }) => {
                            onChange({ ...direccion, block: value });
                        }}
                    />
                </Form.Group>

                <RegionesComunas
                    regionComuna={{ region: direccion.region, comuna: direccion.comuna }}
                    onChange={({ region, comuna }) => {
                        onChange({ ...direccion, region, comuna });
                    }}
                    requeridos={requeridos}
                >
                    <Form.Input
                        label='Villa/Población'
                        placeholder='Los Dinosaurios'
                        value={direccion.poblacion}
                        onChange={(_e, { value }) => {
                            onChange({ ...direccion, poblacion: capitalizar(value) });
                        }}
                        width='8'
                    />
                </RegionesComunas>
            </Panel>
        );
    }
}

export default Direccion;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/Direcciones/componentes/Direccion/index.tsx